export default __webpack_public_path__ + "static/media/Broadway-Regular.f86d1b2c.ttf";